import { createFileRoute, redirect } from '@tanstack/react-router';

/** Legacy URL — public home now lives at `/`. */
export const Route = createFileRoute('/webdesigned/')({
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true });
  },
  component: () => null,
});
